var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasLoaded && _vm.bfh)?_c('div',[_c('BaseSection',{staticClass:"bfh-section"},[_c('BfhsTile',{attrs:{"bfh":_vm.bfh}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }